var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"z-tabs-label",class:_vm.classObject,attrs:{"draggable":"false","href":("#" + _vm.itemId)},on:{"click":function($event){return _vm.toggleItem($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }